import { useEffect, useState } from 'react';
import { announcement, navLinks } from '@/mocks/drama';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="flex h-9 items-center justify-center gap-2 px-4 text-[11px] tracking-wide md:text-xs">
          <i className="ri-megaphone-line text-accent-400" />
          <span className="truncate">{announcement}</span>
        </div>
      </div>

      <nav
        className={`w-full transition-all duration-300 ${
          scrolled
            ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
            : 'border-b border-transparent bg-transparent'
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
          <a href="#home" className={`flex items-center gap-2 ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-wide">欲望的诱惑</span>
          </a>

          <ul className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className={`rounded-md px-3 py-2 text-sm transition-colors ${
                    scrolled
                      ? 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                      : 'text-white/80 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <a
              href="#cast"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              查看完整演员表
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
                scrolled ? 'text-foreground-950 hover:bg-background-200' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {open ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <ul className="mx-auto grid max-w-7xl gap-1 px-4 py-3 md:px-6">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#cast"
                  onClick={() => setOpen(false)}
                  className="mt-1 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
                >
                  查看完整演员表
                </a>
              </li>
            </ul>
          </div>
        ) : null}
      </nav>
    </header>
  );
}